import styled from 'styled-components';
import { Common, device, color } from '@stockbit/ui';

const { Flex } = Common;

const Wrapper = styled.nav`
  background: ${color.light};
  display: none;
  padding: 15px 0;
  position: fixed;
  top: 0;
  transition: all 0.2s ease;
  width: 100%;
  z-index: 0;

  &.down {
    top: 80px;
    z-index: 5;
  }

  @media ${device.laptop} {
    display: block;
  }
`;

const ContentWrapper = styled(Flex).attrs({
  as: 'ul',
})`
  display: none;
  list-style: none;
  max-width: 1300px;

  @media ${device.laptop} {
    align-items: center;
    display: flex;
    justify-content: space-between;
    margin: auto;
    width: calc(100% - 151px);
  }

  li {
    a {
      color: ${color.darkGrey};
      font-size: 16px;
      font-family: var(--regular-font);
      text-decoration: none;

      &:hover {
        color: ${color.highempahis};
      }
    }

    &.active {
      a {
        color: ${color.highempahis};
        font-family: var(--bold-font);
      }
    }
  }
`;

export { ContentWrapper, Wrapper };
